import { extract, successState } from '../actions/global.actions'
import { actions } from '../actions/thresholds.action'

const initialState: ThresholdsState = {
  thresholds: [],
}

const ThresholdsReducer = (state = initialState, action) => {
  switch (action.type) {
    case successState(actions.GET_THRESHOLDS):
      return { ...state, thresholds: extract(action.payload, []) }
    default:
      return state ? state : initialState
  }
}

export default ThresholdsReducer
